module.exports = __webpack_public_path__ + "static/media/home.e1f0afaf.png";